import { ProfileButtonEmailLinkSentStyled } from "./styled/ProfileButtonEmailStyled";
import { BinIcon } from "../../../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { resendUserConfirmEmailAction } from "../../../accountActions";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getUserConfirmEmailLoading, getUserConfirmEmailRequestTime } from "../../../accountSelectors";
import { getUserEmailConfirmedSelector } from "../../../../../app/appSelectors";
import moment from "moment/moment";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext.js";

function ProfileButtonEmailConfirmInfo(props) {
    const {
        className,
        confirmEmailRequestTime,
        confirmEmailLoading,
        resendUserConfirmEmailAction,
        userEmailConfirmed,
    } = props;
    const {getLangPath} = useLangContext();
    const timerRef = useRef(null);
    const [isDelayInProgress, setIsDelayInProgress] = useState(false);

    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (userEmailConfirmed || !confirmEmailRequestTime) {
            return;
        }
        const checkTime = moment().add(-30, 'seconds');
        const requestTime = moment(confirmEmailRequestTime);
        const timeToWaitMs = moment.duration(requestTime.diff(checkTime)).asMilliseconds();
        setIsDelayInProgress(true);
        timerRef.current = setTimeout(() => {
            setIsDelayInProgress(false);
        }, timeToWaitMs);
    }, [confirmEmailRequestTime, userEmailConfirmed]);

    const handleConfirmButtonClick = useCallback(() => {
        resendUserConfirmEmailAction();
    }, [resendUserConfirmEmailAction]);

    return <div className={classNames('d-flex flex-column mt-2', className)}>
        <p className="mb-0">
            {getLangPath(
                isDelayInProgress
                    ? 'sign_up.email_check_inbox'
                    : 'sign_up.email_confirmation_purpose'
            )}
        </p>
        <div className="d-flex justify-content-end mt-2">
            {
                isDelayInProgress ? (
                    <ProfileButtonEmailLinkSentStyled className="d-flex align-items-center">
                        <span>{getLangPath('sign_up.email_link_sent')}</span>
                        <BinIcon name="IcClock" className="ms-2" style={{fill: '#74778A'}}/>
                    </ProfileButtonEmailLinkSentStyled>
                ) : (
                    <Button
                        disabled={confirmEmailLoading}
                        variant="outline-primary"
                        onClick={handleConfirmButtonClick}
                    >
                        <span>{getLangPath('sign_up.confirm')}</span>
                        <BinIcon name="IcArrowRight" className="ms-2" style={{fill: 'var(--color-white)'}}/>
                    </Button>
                )
            }
        </div>
    </div>
}

const mapStateToProps = createStructuredSelector({
    confirmEmailLoading: getUserConfirmEmailLoading,
    confirmEmailRequestTime: getUserConfirmEmailRequestTime,
    userEmailConfirmed: getUserEmailConfirmedSelector,
});


const mapDispatchToProps = {
    resendUserConfirmEmailAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileButtonEmailConfirmInfo);
